import { PayloadAction } from '@reduxjs/toolkit';
import { OrderItem } from 'gql/graphql';
import { CartState } from 'store/cart/types';

const setCartItemsReducer = (state: CartState, action: PayloadAction<OrderItem[]>) => {
  if (!state.cart || !state.cart.carts || !state.cart.carts[0]) return;
  state.cart.carts[0].items = action.payload;
};

export default setCartItemsReducer;
